import { ModelFilter } from 'core/models';

export class LdapUserFilter extends ModelFilter {
    public ldapUsername?: string = '';
}
